import Color from 'color'
import React, { useMemo } from 'react'
import { StyleSheet, ViewStyle } from 'react-native'
import { Button, MD3Colors } from 'react-native-paper'
import { commonColors } from '@linqpal/common-frontend/src/theme'

const styles = StyleSheet.create({
  wrapper: {
    borderRadius: 8,
  },
  content: {
    height: 54,
    padding: 16,
    borderRadius: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    fontSize: 18,
    lineHeight: 22,
    marginVertical: 0,
  },
})

type Props = {
  onPress?: () => void
  children?: React.ReactNode
  loading?: boolean
  uppercase?: boolean
  disabled?: boolean
  buttonColor?: string
  style?: ViewStyle
  rest?: any
  testID?: string
}
export default function SubmitButton({
  onPress = () => null,
  loading = false,
  disabled = false,
  uppercase = false,
  buttonColor,
  style,
  testID = 'submit-button',
  rest,
  children,
}: Props) {
  const { backgroundColor, color } = useMemo(() => {
    const btnColor = buttonColor || commonColors.accentText
    return {
      backgroundColor: !disabled
        ? btnColor
        : Color(btnColor).alpha(0.2).rgb().string(),
      color: MD3Colors.secondary100,
    }
  }, [buttonColor, disabled])

  return (
    <Button
      uppercase={uppercase}
      onPress={onPress}
      disabled={disabled}
      loading={loading}
      mode="contained"
      style={[styles.wrapper, { backgroundColor }, style]}
      contentStyle={styles.content}
      labelStyle={[styles.label, { color }]}
      testID={testID}
      {...rest}
    >
      {children}
    </Button>
  )
}
